export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

// Role hierarchy for RBAC (higher number = more permissions)
export const ROLE_HIERARCHY = {
  operator: 0,
  supervisor: 1,
  admin: 2,
} as const;

export type Role = keyof typeof ROLE_HIERARCHY;
